import { render, staticRenderFns } from "./Suggestions.vue?vue&type=template&id=34eb8a6a&"
import script from "./Suggestions.vue?vue&type=script&lang=js&"
export * from "./Suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports